import { Temperature } from '@features/shipments/models/temperature.model';
import { Model } from '@shared-features/models/model';
import { Expose } from 'class-transformer';
import { Humidity } from './humidity.model';

export class TemperatureAndHumidity extends Model {
  @Expose() temperature: Temperature[];
  @Expose() humidity: Humidity[];
}
